const supportTouch = 'ontouchstart' in window;
const downEventName = supportTouch ? 'touchstart' : 'mousedown';
const moveEventName = supportTouch ? 'touchmove' : 'mousemove';
const upEventName = supportTouch ? 'touchend' : 'mouseup';

/**
 * 获取边界dom
 * @param el
 * @returns {null}
 */
function getBoundaryDom(el) {
  let boundary = null;
  let range = el.__vDragRange;
  if (range) {
    boundary = document.querySelector(range);
    let _el = el.parentNode;
    while (1) {
      if (_el === boundary) break;
      if (_el === document.body || _el === document.documentElement) {
        boundary = null;
        break;
      }
      _el = _el.parentNode;
    }
  }
  return boundary;
}

function getPositionNumber(n, n1, n2) {
  let _n = n;
  if (n1 <= 0) {
    _n = 0;
  } else if (n2 < 0) {
    if (n1 + n2 > 0) {
      _n = n + n2;
    } else {
      _n = n + n1 + n2;
    }
  }
  return _n;
}

/**
 * 校准位置
 * @param el
 * @param left
 * @param top
 * @param right
 * @param bottom
 */
function calibrationPosition(el, left, top, right, bottom) {
  let {__vDragPositionX, __vDragPositionY} = el;
  let rect = el.getBoundingClientRect();
  let x1 = rect.left - left,
    x2 = right - rect.right,
    y1 = rect.top - top,
    y2 = bottom - rect.bottom;
  if (__vDragPositionX == 'right') {
    let x = right - el.offsetLeft - el.offsetWidth;
    let _x = getPositionNumber(x, x2, x1);
    if (x != _x) {
      el.style.right = _x + 'px';
    }
  } else {
    let x = el.offsetLeft;
    let _x = getPositionNumber(x, x1, x2);
    if (x != _x) {
      el.style.left = _x + 'px';
    }
  }
  if (__vDragPositionY == 'bottom') {
    let y = bottom - el.offsetTop - el.offsetHeight;
    let _y = getPositionNumber(y, y2, y1);
    if (_y != y) {
      el.style.bottom = _y + 'px';
    }
  } else {
    let y = el.offsetTop;
    let _y = getPositionNumber(y, y1, y2);
    if (_y != y) {
      el.style.top = _y + 'px';
    }
  }
}

/**
 * 绑定边界
 * @param el
 */
function bindWarpResize(el) {
  let dom = el.__vDragBoundaryDom;
  let _dom = getBoundaryDom(el);
  if (!dom) {
    dom = el.__vDragBoundaryDom = _dom;
  }
  if (dom != _dom) {
    unBindWarpResize(el);
  }
  if (dom) {
    let observer = el.__vDragObserver = new ResizeObserver(() => {
      let rect = dom.getBoundingClientRect();
      calibrationPosition(el, 0, 0, rect.right, rect.bottom);
    });
    observer.observe(dom);
  } else {
    let listener = () => {
      calibrationPosition(el, 0, 0, window.innerWidth, window.innerHeight);
    };
    window.addEventListener('resize', listener);
    el.__vDragObserver = {
      disconnect: () => {
        window.removeEventListener('resize', listener);
      }
    }
  }
}

/**
 * 解绑边界
 * @param el
 */
function unBindWarpResize(el) {
  el.__vDragObserver?.disconnect();
}

/**
 * 获取元素拖动配置
 * @param el
 * @returns {{boundary: null, threshold: (*|number), direction: (*|string)}}
 */
function getOptions(el) {

  let threshold = el.__vDragThreshold;
  if (!dsf.isNumber(threshold) || threshold < 0) {
    threshold = 5;
  }
  if (threshold < 0) {
    threshold = 0;
  }

  let direction = el.__vDragDirection;
  if (direction !== 'horizontal' && direction !== 'vertical') {
    direction = 'both';
  }

  let boundary = getBoundaryDom(el);
  let _range = {left: 0, top: 0, right: window.innerWidth, bottom: window.innerHeight};
  if (boundary) {
    let rect = boundary.getBoundingClientRect();
    _range.left = rect.left;
    _range.top = rect.top;
    _range.right = rect.right;
    _range.bottom = rect.bottom;
  }

  return {
    boundary,
    threshold,
    direction,
    range: _range
  };
}

/**
 * 计算两个点之间的距离
 * @param direction 为方向
 * @param x1
 * @param y1
 * @param x2
 * @param y2
 * @returns {number}
 */
function getDistance(direction, x1, y1, x2, y2) {
  if (direction == 'horizontal') return Math.abs(x1 - x2);
  if (direction == 'vertical') return Math.abs(y1 - y2);
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
}

/**
 * 鼠标按下
 * @param e
 */
function elDown(e) {
  if (this.__vDragDisabled) return;
  let {clientX, clientY} = supportTouch ? e.touches[0] : e;
  let options= getOptions(this);
  dsf.setObjAttr(this, '__vDragOptions', options);
  // 状态，reading等待拖拽，move拖拽中
  dsf.setObjAttr(this, '__vDragStats', options.threshold ? 'reading' : 'move');
  dsf.setObjAttr(this, '__vDragStartX', clientX);
  dsf.setObjAttr(this, '__vDragStartY', clientY);
  // 用元素距离视窗的X、Y坐标，减去el元素最近的相对定位父元素的left、top值
  dsf.setObjAttr(this, '__vDragStartLeft', clientX - this.offsetLeft);
  dsf.setObjAttr(this, '__vDragStartTop', clientY - this.offsetTop);
  if (!options.threshold) {
    this.classList.add('drag-active');
  }

  window.addEventListener(moveEventName, this.__vDragElMove, { passive: false });
  window.addEventListener(upEventName, this.__vDragElUp, { passive: false });

}

/**
 * 鼠标移动
 * @param e
 */
function rootMove(e) {
  let {threshold, direction, range} = this.__vDragOptions;
  let {clientX, clientY} = supportTouch ? e.touches[0] : e;
  if (this.__vDragStats == 'reading') {
    let distance = getDistance(direction, this.__vDragStartX, this.__vDragStartY, clientX, clientY);
    if (distance < threshold) return;
    this.__vDragStartX = clientX;
    this.__vDragStartY = clientY;
    this.__vDragStartLeft = clientX - this.offsetLeft;
    this.__vDragStartTop = clientY - this.offsetTop;
    this.__vDragStats = 'move';
    clearTimeout(this.__vDragTimeout);
    this.classList.add('drag-active');
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  let {left, top, right, bottom} = range;
  let rect = this.getBoundingClientRect();

  if (direction == 'horizontal' || direction == 'both') {
    let newLeft = clientX - this.__vDragStartLeft;
    let diffLeft = newLeft - this.offsetLeft;
    let diff1 = rect.left - left + diffLeft;
    let diff2 = rect.right - right + diffLeft;
    if (diff1 < 0) {
      newLeft -= diff1;
    } else if (diff2 > 0) {
      newLeft -= diff2;
    }
    if (this.__vDragPositionX == 'right') {
      this.style.right = parseInt(dsf.getCss(this, 'right')) - newLeft + this.offsetLeft + 'px';
    } else {
      this.style.left = newLeft + 'px';
    }
  }
  if (direction == 'vertical' || direction == 'both') {
    let newTop = clientY - this.__vDragStartTop;
    let diffTop = newTop - this.offsetTop;
    let diff1 = rect.top - top + diffTop;
    let diff2 = rect.bottom - bottom + diffTop;
    if (diff1 < 0) {
      newTop -= diff1;
    } else if (diff2 > 0) {
      newTop -= diff2;
    }
    if (this.__vDragPositionY == 'bottom') {
      this.style.bottom = parseInt(dsf.getCss(this, 'bottom')) - newTop + this.offsetTop + 'px';
    } else {
      this.style.top = newTop + 'px';
    }
  }
}

/**
 * 鼠标松开
 */
function rootUp() {
  window.removeEventListener(moveEventName, this.__vDragElMove, { passive: false });
  window.removeEventListener(upEventName, this.__vDragElUp, { passive: false });
  this.__vDragTimeout = setTimeout(() => {
    this.classList.remove('drag-active');
  }, 200);
}

/**
 * dom元素拖动
 * 在元素上绑定v-drag指令，即可拖动
 */
export default {
  install(Vue) {
    /**
     * 指令 v-drag
     */
    Vue.directive("drag", {
      inserted(el, { value, expression }) {
        let disabled = expression ? !!value : false;
        dsf.setObjAttr(el, '__vDragDisabled', disabled);
        dsf.setObjAttr(el, '__vDragTimeout', null);
        dsf.setObjAttr(el, '__vDragElDown', elDown.bind(el));
        dsf.setObjAttr(el, '__vDragElMove', rootMove.bind(el));
        dsf.setObjAttr(el, '__vDragElUp', rootUp.bind(el));
        dsf.setObjAttr(el, '__vDragBoundaryDom', null);
        dsf.setObjAttr(el, '__vDragObserver', null);
        dsf.setObjAttr(el, '__vDragBar', el);
        el.__vDragBar.addEventListener(downEventName, el.__vDragElDown);
        if (!disabled) {
          bindWarpResize(el);
        }
      },
      update(el, { value, expression }) {
        let disabled = expression ? !!value : false;
        el.__vDragDisabled = disabled;
        if (!disabled) {
          bindWarpResize(el);
        } else {
          unBindWarpResize(el);
        }
      },
      unbind(el) {
        clearTimeout(el.__vDragTimeout);
        unBindWarpResize(el);
        window.removeEventListener(moveEventName, el.__vDragElMove, { passive: false });
        window.removeEventListener(upEventName, el.__vDragElUp, { passive: false });
        el.__vDragBar.removeEventListener(downEventName, el.__vDragElDown);
      }
    });
    /**
     * 指令 v-drag-position-bar {string}
     * css选择器，鼠标放在该元素上才允许拖动
     */
    Vue.directive("drag-position-bar", {
      inserted(el, { value }) {
        let bar = value;
        if (bar) bar = el.querySelector(bar);
        if (!bar) bar = el;
        if (el.__vDragBar != bar) {
          el.__vDragBar?.removeEventListener(downEventName, el.__vDragElDown);
          bar.addEventListener(downEventName, el.__vDragElDown);
          dsf.setObjAttr(el, '__vDragBar', bar);
        }
      },
      update(el, { value }) {
        let bar = value;
        if (bar) bar = el.querySelector(bar);
        if (!bar) bar = el;
        if (el.__vDragBar != bar) {
          el.__vDragBar.removeEventListener(downEventName, el.__vDragElDown);
          bar.addEventListener(downEventName, el.__vDragElDown);
          el.__vDragBar = bar;
        }
      }
    });
    /**
     * 指令 v-drag-position-x {string}
     * left 表示元素基于左边界对齐，right表示元素基于右边界对齐
     */
    Vue.directive("drag-position-x", {
      inserted(el, { value, expression }) {
        let position = value || expression || 'left';
        dsf.setObjAttr(el, '__vDragPositionX', position);
      },
      update(el, { value, expression }) {
        el.__vDragPositionX = value || expression || 'left';
      }
    });
    /**
     * 指令 v-drag-position-y {string}
     * top 表示元素基于上边界对齐，bottom表示元素基于下边界对齐
     */
    Vue.directive("drag-position-y", {
      inserted(el, { value, expression }) {
        let position = value || expression || 'top';
        dsf.setObjAttr(el, '__vDragPositionY', position);
      },
      update(el, { value, expression }) {
        el.__vDragPositionY = value || expression || 'top';
      }
    });
    /**
     * 指令 v-drag-threshold {number}
     * 当按下鼠标移动了n个像素时才会触发拖拽。默认为5
     */
    Vue.directive("drag-threshold", {
      inserted(el, { value }) {
        dsf.setObjAttr(el, '__vDragThreshold', value);
      },
      update(el, { value }) {
        el.__vDragThreshold = value;
      }
    });
    /**
     * 指令 v-drag-range {string} 传入css选择器
     * 拖拽边界，边界dom必须包裹目标dom，拖拽时，会限制在边界内。
     * 不传值时，边界为整个可视窗口
     */
    Vue.directive("drag-range", {
      inserted(el, { value }) {
        dsf.setObjAttr(el, '__vDragRange', value || 'body');
        bindWarpResize(el);
      },
      update(el, { value }) {
        el.__vDragRange = value || 'body';
        bindWarpResize(el);
      }
    });
    /**
     * 指令 v-drag-direction {string}
     * 拖拽方向：horizontal 水平，vertical 垂直，both 双向。默认为both
     */
    Vue.directive("drag-direction", {
      inserted(el, { value }) {
        dsf.setObjAttr(el, '__vDragDirection', value);
      },
      update(el, { value }) {
        el.__vDragDirection = value;
      }
    });
  }
};